<template>
  <div class="page-main">
    <page-title />
    <page-card>
      <template slot="tab">
        <el-tabs v-model="active" class="page-tab" @tab-click="handleClick">
          <el-tab-pane name="OIL">
            <span slot="label">
              <svg-icon v-if="active === 'OIL'" icon-class="tn-oil" />
              <svg-icon v-else icon-class="tn-oil1" />
              Oil({{ oilTotal }})
            </span>
          </el-tab-pane>
          <el-tab-pane name="GAS">
            <span slot="label">
              <svg-icon v-if="active === 'GAS'" icon-class="tn-gas2" />
              <svg-icon v-else icon-class="tn-gas" />
              Gas({{ gasTotal }})
            </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template slot="header">
        <div class="spaceBetween">
          <span>Producer Well List</span>
          <div>
            <el-input
              v-model="searchData.nickname"
              class="search-input"
              placeholder="Enter well name to search…"
              @keyup.enter="getList"
            >
              <el-button slot="append" size="mini" @click="getList">
                <svg-icon icon-class="tn-search" />
              </el-button>
            </el-input>
          </div>
        </div>
      </template>
      <div slot="body" class="page-table" style="margin-top: -12px">
        <el-table v-loading="loading" stripe :data="tableList" highlight-current-row>
          <el-table-column prop="registrationDate" label="Submission Date" width="220px">
            <template slot-scope="{ row }">{{
              row.timestamp | time("yyyy-MM-DD")
            }}</template>
          </el-table-column>
          <el-table-column
            prop="userID"
            label="treasurenet Account"
            show-overflow-tooltip
          />
          <el-table-column prop="nickname" label="Well Name" />
          <el-table-column prop="Operation" label="Operation" width="150px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="toApprove(row)">Review</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-bottom-btn">
          <pagination
            :total="queryParams.total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pageSize"
            @pagination="getList()"
          />
        </div>
      </div>
    </page-card>
  </div>
</template>

<script>
import { approvalWellList } from '@/api/manager.js'
export default {
  components: {},
  data() {
    return {
      active: 'OIL',
      loading: false,
      searchData: {
        nickname: undefined
      },
      tableList: [],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      oilTotal: 0,
      gasTotal: 0
    }
  },
  computed: {},
  created() {
    this.getList()
  },
  methods: {
    handleClick() {
      this.queryParams.page = 1
      this.getList()
    },
    getList() {
      const param = {
        status: '0',
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        nickname: this.searchData.nickname,
        type: this.active
      }
      this.loading = true
      approvalWellList(param)
        .then((res) => {
          this.loading = false
          this.tableList = res.result.list
          this.queryParams.total = res.result.total
          this.oilTotal = res.result.oilwells
          this.gasTotal = res.result.gaswells
        })
        .catch(() => {
          this.loading = false
        })
    },
    getWellTime(row) {
      if (row.well) {
        return this.moment(new Date(row.well.timestamp)).fromNow()
      } else if (row.timestamp) {
        return this.moment(new Date(row.timestamp)).fromNow()
      }
    },
    toApprove(row) {
      this.$router.push({
        path: '/wellManagement/approve/details',
        query: {
          wellID: row.wellID
        }
      })
    }
  }
}
</script>
<style scoped lang="scss"></style>
